import { ReactNode } from 'react';
import { cn } from '~/lib/cn';

interface Props {
    title: ReactNode;
    /** Optional sub-line under the title. */
    description?: ReactNode;
    /** Optional controls, right-aligned on the title row. */
    actions?: ReactNode;
    className?: string;
}

// The single heading style for dashboard sections and action-grid columns — keeps every section identical.
export default function SectionHeading({ title, description, actions, className }: Props) {
    return (
        <div className={cn('tw-flex tw-flex-wrap tw-items-end tw-justify-between tw-gap-4', className)}>
            <div className="tw-flex tw-flex-col tw-gap-1">
                <h5 className="tw-m-0 tw-text-lg tw-font-semibold tw-text-accents-9">{title}</h5>
                {description && <p className="tw-m-0 tw-text-xs tw-text-accents-8">{description}</p>}
            </div>
            {actions}
        </div>
    );
}
